<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="16">
            <el-form-item label="名称" prop="name"><el-input v-model="formParameter.name"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用旧名字" prop="isUseOldname">
              <el-checkbox v-model="formParameter.isUseOldname"></el-checkbox></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片链接" prop="url">
              <!-- <el-input v-model="formParameter.url" autocomplete="off"></el-input> -->
              <image-upload v-model="formParameter.url" @change="callBacklogoUrl" model="fileSystem"
                uri="/statics/online" :size="80000"></image-upload>
                <ul>
                    <li>【课程图片】标准大小为：300 x 180</li>
                    <li>【app截图】标准大小为：501 x 1083</li>
                    <li>【项目流程、合作单位图片】标准大小为：1539 x 396</li>

                </ul>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="formParameter.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import api from "@/api/online/onlinephoto/onlinephoto.js";
import constant from '@/util/constant.js';
export default {
  name: "edit",
  components: {
    popup,
    imageUpload
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      isSuccess: false,
      baseUrl: constant.serverUrl + "/",
      rules: {
        //
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ],
        //图片链接
        url: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {
    callBacklogoUrl(fname) {
      if (fname) {
        this.formParameter.url = this.baseUrl + fname.substring(fname.lastIndexOf("/statics/online"));
      }
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        let parameter = this.$utils.merger(this.formParameter);
        //处理下可用状态判断
        parameter.disabled = parameter.disabled ? 1 : 2;

        //验证模块类型是否有限
        let params = {
          type: parameter.type,
          sorts: parameter.sorts
        };
        api.verifySorts(params, (response) => {
          console.log('66666666666',response);
          if (response.data.isSuccess) {
            this.$utils.msg.success(response.msg);

            //处理图片路径问题
          if (!this.parameter.id) {
            //添加
            api.save(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.close();
                this.$parent.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
                this.confirmLoading = false;
              }
            );
          } else {
            //编辑
            api.update(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.close();
                this.$parent.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
                this.confirmLoading = false;
              }
            );
          }

          this.confirmLoading = false;

          } else{
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        });

      });
    },

    init() {

      //this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.formParameter.url = this.baseUrl + this.formParameter.url;

          if (this.formParameter.disabled == 1) {
            this.formParameter.disabled = true;
          } else {
            this.formParameter.disabled = false;
          }

          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
